import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  buttonStyle: {
    fontSize: 32,
    borderRadius: 21,
    boxShadow:
      "-5px 3px 7px 2px rgba(0, 0, 0, 0.2), 0 4px 4px 0 rgba(0, 0, 0, 0.19) inset",
  },
  selected: {
    backgroundColor: "#ffffff",
    color: "#000",
  },
});

const BigTab = ({ onClick, disabled, className, children }) => {
  const classes = useStyles();
  return (
    <Button
      className={[classes.buttonStyle, className]}
      onClick={onClick}
      disabled={disabled}
      variant="contained"
      color="primary"
    >
      {children}
    </Button>
  );
};

export default BigTab;
